import React from "react";
import "./about.css";
import { Container, Row, Col } from "react-bootstrap";
import Cap from "./image/cap.png";
import IFROS from "./image/IFROS.png";
import MIST from "./image/MIST.png";
import DCC from "./image/DCC.png";
import AK from "./image/AKK.png";

export default function Academic() {
  return (
    <div style={{ marginTop: 50, color: "white", fontSize: 20, fontFamily: "serif" }}>
      <Container>
        {/* Master's Degree */}
        <Row className="align-items-center mb-5">
          <Col xs={12} md={9}>
            <h3>
              <img src={Cap} alt="badge" className="icons-about img-fluid" />{" "}
              <u>Master of Science (M.Sc.)</u>
            </h3>
            <p>
              <a href="https://ifrosmaster.org/program" style={{ color: "white" , textDecoration: "none"}}>
                Erasmus Mundus Joint Master in Intelligent Field Robotic Systems
                (IFRoS)
              </a>
            </p>
            <p>
              <a href="https://www.udg.edu/ca/" style={{ color: "white", textDecoration: "none"}}>
                Universitat de Girona (UdG), Spain
              </a>
            </p>
            <p>
              <a href="https://www.elte.hu/en/" style={{ color: "white" , textDecoration: "none"}}>
                Eötvös Loránd University (ELTE), Hungary
              </a>
            </p>
            <p>CGPA: 8.15/10.0</p>
             <p>Thesis GPA: 9.0 [Excellent]</p>
            <p>
              <i>2023-2025</i>
            </p>
          </Col>
          <Col xs={12} md={3} className="text-center">
            <img src={IFROS} alt="IFRos" className="image-about img-fluid" />
          </Col>
        </Row>

        {/* Bachelor's Degree */}
        <Row className="align-items-center mb-5">
          <Col xs={12} md={9}>
            <h3>
              <img src={Cap} alt="badge" className="icons-about img-fluid" />{" "}
              <u>Bachelor of Science (B.Sc.)</u>
            </h3>
            <p>
              <a href="https://mist.ac.bd/department/eece" style={{ color: "white" , textDecoration: "none"}}>
                Military Institute of Science and Technology (MIST)
              </a>
            </p>
            <p>B.Sc. in Electrical, Electronic and Communication Engineering (EECE)</p>
            <p>CGPA: 3.68/4.0</p>
             <p>Thesis GPA: 4.0 [A+]</p>
            <p>Dhaka, Bangladesh</p>
            <p>
              <i>2018-2022</i>
            </p>
          </Col>
          <Col xs={12} md={3} className="text-center">
            <img src={MIST} alt="MIST" className="image-about img-fluid" />
          </Col>
        </Row>

        {/* Higher Secondary Certificate */}
        <Row className="align-items-center mb-5">
          <Col xs={12} md={9}>
            <h3>
              <img src={Cap} alt="badge" className="icons-about img-fluid" />{" "}
              <u>Higher Secondary Certificate (HSC)</u>
            </h3>
            <p>
              <a href="https://www.dhakacitycollege.edu.bd/" style={{ color: "white" , textDecoration: "none"}}>
                Dhaka City College
              </a>
            </p>
            <p>GPA: 5.00/5.00</p>
            <p>Dhaka, Bangladesh</p>
            <p>
              <i>2017</i>
            </p>
          </Col>
          <Col xs={12} md={3} className="text-center">
            <img src={DCC} alt="DCC" className="image-about img-fluid" />
          </Col>
        </Row>

        {/* Secondary School Certificate */}
        <Row className="align-items-center mb-5">
          <Col xs={12} md={9}>
            <h3>
              <img src={Cap} alt="badge" className="icons-about img-fluid" />{" "}
              <u>Secondary School Certificate (SSC)</u>
            </h3>
            <p>
              <a href="https://akschoolandcollege.edu.bd/" style={{ color: "white" , textDecoration: "none"}}>
                A.K High School and College
              </a>
            </p>
            <p>GPA: 5.00/5.00</p>
            <p>Dhaka, Bangladesh</p>
            <p>
              <i>2015</i>
            </p>
          </Col>
          <Col xs={12} md={3} className="text-center">
            <img src={AK} alt="AK" className="image-about img-fluid" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
